import { useAxios } from "@hooks"
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Query } from "@types";


export const useGetCatalogExams = (examQuery: Query, enabled: boolean = true) => {
    const axios = useAxios();
    const {t} = useTranslation();

    const getExams = async () => {
        try {
            const response = await axios.get("/api/exam/catalog", {params: examQuery});
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.getExams"));
        }
    }

    return useQuery({queryKey: ["exams", examQuery], queryFn: getExams, staleTime: Infinity, enabled})
}